import request from './request.js';

export default{

    // ====================================== 修改 ======================================

    //修改公司维护人
    SetCompanyTBEmployee(params) {
      //拼接参数： jobNumber 操作人员工工号  companyId 工厂公司编号  employeeJobNumber 工厂维护人员工工号
      return request({
        url: '/Company/SetCompanyTBEmployee' + params,
        method: 'post',
      });
    },
    //修改公司使用系统类型
    SetCompanySystemType(params) {
      //拼接参数： jobNumber 操作人员工工号  companyId 工厂公司编号  systemTypeId 系统类型编号
      return request({
        url: '/Company/SetCompanySystemType' + params,
        method: 'post',
      });
    },

    // ====================================== 查询 ======================================

    //查询单个公司信息
    getCompanyInfo(params){
      //拼接参数：companyId 公司编号  tbEmployeeJobNumber 牙管家员工工号  likeCompanyName模糊查询 工厂公司名称  
			// provinceCode 省份编码  cityCode 城市编码  areaCode 区县编码 systemTypeId 系统类型编号
      return request({
        url: '/Company/GetCompany' + params,   // code: 200 success
        method: 'get'
      });
    },
    //查询所有公司信息 列表
    getCompanyList(params){
      // 拼接参数（可带可不带）：tbEmployeeJobNumber(string) 员工工号  companyId 公司编号 likeCompanyName 模糊查询工厂公司名称 systemTypeId 系统类型编号 provinceCode cityCode areaCode 省市区编号
      return request({
        url: '/Company/GetAllCompany' + params,   // code: 200 success
        method: 'get',
      });
    },
    //获取公司穿透信息
    getAllCompanyFrp(params){
      //拼接参数： companyId 公司编号
      return request({
        url: '/Company/GetAllCompanyfrp' + params,   // code: 200 success
        method: 'get'
      });
    },
    //获取公司版本信息
    getAllCompanyVersion(params){
      //拼接参数： companyId 公司编号
      return request({
				url: '/Software/PaginatedSoftwareVersion' + params,   // code: 200 success
        // url: '/Company/GetAllCompanyVersion' + params,   // code: 200 success
        method: 'get'
      });
    },
    // 获取工厂-公司版本信息
    getAllPlantVersion(params){
      return request({
        url:'/Company/GetAllCompanyVersion'+params,
        method: 'get'
      })
    },
    //获取公司升级记录信息
    getAllCompanyVersionLog(params){
      //拼接参数： companyId 公司编号
      return request({
        url: '/Company/GetAllCompanyVersionLog' + params,   // code: 200 success
        method: 'get'
      });
    },
    //获取公司续费记录信息
    getAllGetAllDredgeLog(params){
      //拼接参数： companyId 公司编号
      return request({
        url: '/Company/GetAllDredgeLog' + params,   // code: 200 success
        method: 'get'
      });
    },
    // 获取工厂-公司信息--分页
    getAllPlantMsgPag(pagind,pagsize,params){
      return request({
        url:`/Company/PaginatedCompany/${pagind}/${pagsize}`,
        method:'post',
        data:params
      })
    },
    // 获取工厂-公司版本信息--分页
    getAllPlantVersionPag(pagind,pagsize,params){
      return request({
        url:`/Company/PaginatedCompanyVersion/${pagind}/${pagsize}`,
        method:'post',
        data:params
      })
    },
    // 获取工厂-公司升级记录信息--分页
    getAllCompanyVersionLogPag(pagind,pagsize,params){
      return request({
        url:`/Company/PaginatedCompanyVersionLog/${pagind}/${pagsize}`,
        method:'post',
        data:params
      })
    },
    // 获取工厂-公司续费记录信息--分页
    getPaginatedDredgeLogPag(pagind,pagsize,params){
      return request({
        url:`/Company/PaginatedDredgeLog/${pagind}/${pagsize}`,
        method:'post',
        data:params
      })
    },
    getAllMsgLog(pagind,pagsize,params){
      return request({
        url:`/Company/PaginatedPermission/${pagind}/${pagsize}`,
        method:'post',
        data:params
      })
    },
    // 查询所有错误信息
    getAllErrorLog(pagind,pagsize,params){
      return request({
        url:`/Company/PaginatedCompanyErrorLog/${pagind}/${pagsize}`,
        method:'post',
        data:params
      })
    },
    // 添加错误信息
    addErrorLog(params){
      return request({
        url:`/Company/InsertErrorLog`,
        method:'post',
        data:params
      })
    },
    // 删除错误信息
    deleteErrorLog(params){
      return request({
        url:`/Company/DeleteErrorLog${params}`,
        method:'post',
      })
    },
}
